module.exports = "varying vec4 parVel;\nvarying vec2 vUv;\nuniform sampler2D picture;\nuniform float opacity;\n\nvoid main() {\n\n    vec4 rainbow = parVel;\n\n// vec4 outputColor = vec4(\n//         (rainbow.x + 0.6),\n//         (rainbow.y * rainbow.x + 0.6),\n//         (rainbow.y + 0.6),\n//         0.25\n//     );\n// outputColor.xyz = clamp(outputColor.xyz, vec3(0.0), vec3(1.0));\n    vec4 imgColor = texture2D(picture, vUv);\n\n    vec4 outputColor = vec4(0.5, 0.5, 0.5, opacity) * imgColor;\n\n    gl_FragColor = outputColor;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/scene-builder/Details/GPUParticles/particle.frag
// module id = 681
// module chunks = 2